import { Tag } from "@chakra-ui/react";
import { PatientServicePlanStatus } from "../../../shared/schema/gql/graphql";

/**
 * The GraphQL enum and the REST schema's string union carry the same values, so
 * the template-literal form accepts either — one tag serves the agency-wide
 * dashboard, the patient's plan list and the plan editor.
 */
type Status = `${PatientServicePlanStatus}`;

interface Props {
  status: Status;
}

export default function ServicePlanStatusTag({ status }: Props) {
  switch (status) {
    case "DRAFT":
      return <Tag colorScheme="yellow">Draft</Tag>;
    case "FINALIZED":
      return <Tag colorScheme="green">Finalized</Tag>;
  }
}
